import { render } from "./ReceiptView.vue?vue&type=template&id=4d83e459"
import script from "./ReceiptView.vue?vue&type=script&lang=js"
export * from "./ReceiptView.vue?vue&type=script&lang=js"

import "./ReceiptView.vue?vue&type=style&index=0&id=4d83e459&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__